import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Teleport as _Teleport, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "collection-effect"
};
const _hoisted_2 = {
  class: "reply-text"
};
const _hoisted_3 = {
  key: 0,
  class: "keyword-content min-h-12 mt-3"
};
const _hoisted_4 = {
  key: 0,
  class: "key-word mt-3"
};
const _hoisted_5 = {
  class: "relative swiper-block"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 0,
  class: "navigation-block"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "left-box"
};
const _hoisted_11 = {
  class: "text-xs"
};
const _hoisted_12 = {
  class: "right-box flex items-center"
};
const _hoisted_13 = {
  class: "flex item-center"
};
const _hoisted_14 = ["title"];
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import { computed, ref, watch, nextTick } from 'vue';
import { ArrowDownBold, Back, Right } from '@element-plus/icons-vue';
import MenuBlock from '@components/MenuBlock.vue';
import { getModelName } from '@views/main/config';
import AnimateText from '../AnimateText.vue';
import useMainStore from '../../main.store';
export default /*@__PURE__*/_defineComponent({
  __name: 'ModelInclusion',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const swiperRef = ref();
    const mainStore = useMainStore();
    const AnimateTextRef = ref();
    const activeIns = ref(0);
    const show = ref(true);
    const loading = ref(false);
    const currentIns = ref(0);
    const fold = ref(false);
    const initialIns = ref(0);
    const showPreview = ref(false);
    const info = computed(() => {
      if (props.content) {
        try {
          // const obj = props.content
          // obj.includeDetails = obj.includeEffectDetails.map(item => {
          //   item.result.forEach(r => {
          //     r.src = r.remotePath
          //   })
          //   return { keyword: item.keyword, collectionList: item.result }
          // })
          // return obj
          return {
            ...props.content,
            includeDetails: props.content.includeEffectDetails.map(item => {
              // 创建新的 result 数组，不修改原始数据
              const result = item.result.map(r => ({
                ...r,
                src: r.remotePath
              }));
              return {
                keyword: item.keyword,
                collectionList: result
              };
            })
          };
        } catch {
          return {
            includeDetails: []
          };
        }
      }
      return {
        includeDetails: []
      };
    });
    const tabList = computed(() => {
      const list = [];
      info.value.includeDetails.forEach((item, ins) => {
        list.push({
          label: item.keyword || '',
          value: ins
        });
      });
      return list;
    });
    const activeItem = computed(() => {
      return info.value.includeDetails[activeIns.value] || {
        collectionList: []
      };
    });
    const currentItem = computed(() => {
      try {
        return info.value.includeDetails[activeIns.value].collectionList[currentIns.value];
      } catch {
        return {};
      }
    });
    const srcList = computed(() => {
      const list = [];
      activeItem.value.collectionList.forEach(item => {
        list.push(item.src);
      });
      return list;
    });
    function handleClickPreview(ins) {
      initialIns.value = ins;
      currentIns.value = ins;
      showPreview.value = true;
    }
    function handleEnd() {
      show.value = true;
      loading.value = true;
      setTimeout(() => {
        loading.value = false;
        mainStore.loadNextMsg(props.item);
      }, 2000);
    }
    function changeTab() {
      currentIns.value = 0;
    }
    function switchFold() {
      fold.value = !fold.value;
    }
    function setFirstSwiper(swiper) {
      swiperRef.value = swiper;
      swiper.slideTo(0);
    }
    function handleSlideChange(swiper) {
      currentIns.value = swiper.activeIndex;
    }
    function handleClick(ins) {
      swiperRef.value.slideTo(ins);
    }
    function next() {
      swiperRef.value.slideNext();
    }
    function prev() {
      swiperRef.value.slidePrev();
    }
    watch(() => props.item.openAnimate, async newVal => {
      if (newVal) {
        show.value = false;
        await nextTick();
        AnimateTextRef.value?.typeWriter(info.value.tips || '');
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_image_viewer = _resolveComponent("el-image-viewer");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(AnimateText, {
        ref_key: "AnimateTextRef",
        ref: AnimateTextRef,
        text: __props.item.openAnimate ? '' : info.value.tips,
        onEnd: handleEnd
      }, null, 8, ["text"])]), show.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(MenuBlock, {
        modelValue: activeIns.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeIns.value = $event),
        list: tabList.value,
        onChange: changeTab
      }, null, 8, ["modelValue", "list"]), !loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_unref(Swiper), {
        onSwiper: setFirstSwiper,
        onSlideChange: handleSlideChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeItem.value.collectionList, (item, ins) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            key: ins
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "img-box w-full bg-[#FAFBFB] relative",
              onClick: $event => handleClickPreview(ins)
            }, [_createElementVNode("img", {
              src: item.src,
              alt: "",
              class: "w-full h-full object-contain select-none"
            }, null, 8, _hoisted_7)], 8, _hoisted_6)]),
            _: 2
          }, 1024);
        }), 128)), activeItem.value.collectionList.length > 1 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("div", {
          class: _normalizeClass(["swiper-button-prev", {
            disabled: currentIns.value === 0
          }]),
          onClick: prev
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Back))]),
          _: 1
        })], 2), _createElementVNode("div", {
          class: _normalizeClass(["swiper-button-next", {
            disabled: currentIns.value === activeItem.value.collectionList.length - 1
          }]),
          onClick: next
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Right))]),
          _: 1
        })], 2)], 64)) : _createCommentVNode("", true)]),
        _: 1
      }), activeItem.value.collectionList.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeItem.value.collectionList, (son, sonIns) => {
        return _openBlock(), _createElementBlock("span", {
          key: son.id,
          class: _normalizeClass(["collection-item cursor-pointer", {
            active: sonIns === currentIns.value
          }]),
          onClick: $event => handleClick(sonIns)
        }, null, 10, _hoisted_9);
      }), 128))])) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: _normalizeClass(["footer-info flex justify-between items-center px-3", {
          active: fold.value
        }])
      }, [_createElementVNode("div", _hoisted_10, [_cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "text-sm"
      }, "收录时间：", -1)), _createElementVNode("span", _hoisted_11, _toDisplayString(currentItem.value.createDate || '--'), 1)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[3] || (_cache[3] = _createTextVNode(" 收录模型： ", -1)), _createElementVNode("div", {
        class: "truncate max-w-[140px]",
        title: _unref(getModelName)(currentItem.value.model)?.label || currentItem.value.model
      }, _toDisplayString(_unref(getModelName)(currentItem.value.model)?.label || currentItem.value.model), 9, _hoisted_14)]), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "w-px h-3 bg-[#E5E6EB] mx-2"
      }, null, -1)), _createElementVNode("div", {
        class: "flex items-center cursor-pointer",
        onClick: switchFold
      }, [_cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "whitespace-nowrap text-[#86909C]"
      }, "收录说明", -1)), _createVNode(_component_el_icon, {
        class: "text-[#86909C] cursor-pointer ml-1"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ArrowDownBold))]),
        _: 1
      })])])], 2)])) : _createCommentVNode("", true)])), [[_directive_loading, loading.value]]) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["animate-box", {
          active: fold.value
        }])
      }, [...(_cache[6] || (_cache[6] = [_createStaticVNode("<div class=\"footer-tip\" data-v-40a18e24><p class=\"text-[#4E5969] mb-5\" data-v-40a18e24>关于效果波动的说明：</p><p class=\"text-[#86909C]\" data-v-40a18e24>展示效果会存在一定波动，这是由多种因素共同导致的：</p><p class=\"text-[#86909C]\" data-v-40a18e24>1.AI大模型不断更新其知识库与响应算法</p><p class=\"text-[#86909C]\" data-v-40a18e24>2.市场竞争环境持续变化</p><p class=\"text-[#86909C]\" data-v-40a18e24>3.用户提问方式和搜索上下文各不相同</p><p class=\"text-[#86909C] mt-5\" data-v-40a18e24>为确保品牌展示效果稳定，我们的系统将：</p><p class=\"text-[#86909C]\" data-v-40a18e24>1.进行每日信息更新与效果监测</p><p class=\"text-[#86909C]\" data-v-40a18e24>2.根据市场动态自动调整展示策略</p><p class=\"text-[#86909C]\" data-v-40a18e24>3.主动进行持续性优化与查漏补缺</p><p class=\"text-[#86909C] mt-5\" data-v-40a18e24> 建议您定期查看效果分析报告，了解品牌在AI搜索中的展示情况及优化建议。 </p></div>", 1)]))], 2), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [showPreview.value ? (_openBlock(), _createBlock(_component_el_image_viewer, {
        key: 0,
        "url-list": srcList.value,
        "show-progress": "",
        "initial-index": initialIns.value,
        onClose: _cache[1] || (_cache[1] = $event => showPreview.value = false)
      }, null, 8, ["url-list", "initial-index"])) : _createCommentVNode("", true)]))]);
    };
  }
});